import { useRef } from 'react';

import { Button } from '@components/button';
import { FileInput, FileInputProps } from '@components/file-field/file-input';
import { IconReplace } from '@components/icons/replace';
import { IconUpload } from '@components/icons/upload';
import { useScopedTranslate } from '@locale/translate';

export type FileButtonProps = Pick<FileInputProps, 'fileType'> & {
  onFileSelected(file: File): void;
  addText?: string;
  replaceText?: string;
  isReplace?: boolean;
};

export const FileButton = ({
  onFileSelected,
  fileType,
  addText,
  replaceText,
  isReplace,
}: FileButtonProps) => {
  const { t } = useScopedTranslate(locale);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const addTextFinal = addText ?? t('add');
  const replaceTextFinal = replaceText ?? t('replace');

  return (
    <>
      <FileInput fileType={fileType} ref={fileInputRef} onChange={onFileSelected} />
      <Button
        variant="secondary"
        onClick={() => fileInputRef.current?.click()}
        text={isReplace ? replaceTextFinal : addTextFinal}
        iconLeft={isReplace ? <IconReplace /> : <IconUpload />}
      />
    </>
  );
};

export const locale = {
  en: {
    add: 'Add',
    replace: 'Replace',
  },
};
